import { updateservice, createservice, deleteservice } from './crudservice';
import { store } from '..';

export default function(entry, operation) {
  const tnms = store.getState().tnms.all;
  const invoices = store.getState().invoices.all;
  const labor = store.getState().labor.entries;
  const backupEntry = labor.find(
    be =>
      be.workordernumber === entry.workordernumber &&
      be.dateperformed === entry.dateperformed
  );
  var temptm = tnms.find(
    tm =>
      tm.wedate === entry.wedate && tm.workordernumber === entry.workordernumber
  );
  console.log('movetime', temptm);
  console.log('movetime backupEntry', backupEntry);
  console.log('movetime entry', entry);
  let entrycharge = entry.hours * parseFloat(entry.payrate);
  var chargediff =
    (entry.hours - (backupEntry ? backupEntry.hours : 0)) *
    parseFloat(entry.payrate);
  console.log('movetime chargediff $' + chargediff);
  if (temptm) {
    var backuptm = Object.assign({}, temptm);
    entry = { ...entry, tmnumber: temptm.tmnumber.toString(), tmind: 1 };
    console.log('Found Applicable TNM', temptm);
    console.log(
      'movetime TNM initial laborfee ',
      '$' + temptm.laborfee + 'movetime TNM initial amount ' + temptm.amount
    );
    temptm = {
      ...temptm,
      laborfee: temptm.laborfee + chargediff,
      amount: temptm.amount + chargediff
    };

    console.log(
      'movetime TNM new laborfee ',
      '$' + temptm.laborfee + 'movetime TNM new amount ' + temptm.amount
    );
    updateservice('tmsheets', temptm, temptm.id, 'T & M').then(response => {
      let tempinv = invoices.find(
        inv =>
          inv.number == temptm.invoicenumber &&
          inv.workordernumber === temptm.workordernumber
      );
      console.log('movetime invoice', tempinv);
      if (tempinv && !tempinv.fixedpriceinv) {
        console.log('movetime current invoice amount ' + tempinv.amount);
        tempinv = { ...tempinv, amount: tempinv.amount + chargediff };
        console.log('movetime invoice chargediff ' + chargediff);
        console.log('movetime new invoice amount ' + tempinv.amount);
        updateservice('invoices', tempinv, tempinv.id, 'Invoices');
      } else if (tempinv.fixedpriceinv) {
        console.log('Invoice is fixed price');
      }
    });
  }
  switch (operation) {
    case 'create':
      if (entry.hours) {
        console.log('creating entry ', entry);
        createservice('dailylaborentries', entry, 'Labor');
      }

      break;
    case 'delete':
      if (entry.id) {
        deleteservice('dailylaborentries', entry.id);
      }
      break;
    case 'patch':
      updateservice('dailylaborentries', entry, entry.id, 'Labor');

      break;
    default:
  }
}



// WEBPACK FOOTER //
// ./src/services/movetime.js